import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../Sidebar";
import { useRemoteSigningNotice } from '@/modules/remote-signing/useRemoteSigningNotice';

interface MainLayoutProps {
  children: React.ReactNode;
}

const pageTitles: { [key: string]: string } = {
  "/dashboard": "Dashboard",
  "/contacts": "Contactos",
  "/certificates": "Certificados",
  "/documents": "Documentos",
  "/dossiers": "Expedientes",
};

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation();
  const { companyPending } = useRemoteSigningNotice();
  const remoteNotice = companyPending ? (
    <p role="status" className="alert-legal alert-legal-info mb-5 text-sm">
      Tu empresa tiene habilitada la firma remota, pero aún no hay miembros habilitados. Comunícate con el administrador de la plataforma para solicitarlo.
    </p>
  ) : null;

  const getPageTitle = () => {
    return pageTitles[location.pathname] || "Plussigner";
  };

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const footer = (
    <footer className="mt-8 border-t border-slate-200/80 pt-4 text-center text-xs text-slate-500">
      Plussigner v2.0.0, un producto de{" "}
      <a
        href="https://saeta.pe/"
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-slate-700 hover:text-slate-900 transition-colors"
      >
        Saeta
      </a>
      .
    </footer>
  );

  return (
    <div className="min-h-screen bg-white">
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={handleToggleSidebar}
      />

      {/* Una sola instancia de la página también conserva el estado al cambiar de tamaño. */}
      <div
        className={`flex flex-col min-h-screen xl:h-screen transition-all duration-300 ${
          isSidebarCollapsed ? "xl:ml-16" : "xl:ml-64"
        }`}
      >
        <div className="xl:hidden header-legal flex items-center justify-between h-16 px-4 flex-shrink-0">
          <div className="w-12"></div>
          <h1 className="text-base sm:text-lg font-semibold text-navy text-center truncate">
            {getPageTitle()}
          </h1>
          <div className="w-10"></div>
        </div>

        <main className="flex-1 xl:min-h-0 xl:overflow-auto bg-white">
          <div className="p-4 xl:p-6 min-h-full">
            <div className="max-w-7xl mx-auto">
              {remoteNotice}
              {children}
              {footer}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
